<script>
import compoment from '@/components/draggable/CustomComponents/Input/DInputEditor'
export default {
  name: 'DNumberInputEditor',
  extends: compoment
}
</script>
